var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOtMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Search_results_for_Log_out_-_Flaticon-2_2_",
    "data-name": "Search results for Log out - Flaticon-2 (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.989,
    height: 27.961,
    viewBox: "0 0 24.989 27.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3372",
    "data-name": "Path 3372",
    d: "M39.5,23.507V24.9a2.983,2.983,0,0,1-1.525,2.641,2.982,2.982,0,0,1-3.049,0l-6.2-3.577A2.983,2.983,0,0,1,27.2,21.324V3.049A3.053,3.053,0,0,1,30.253,0H43.9a3.053,3.053,0,0,1,3.05,3.049V6.9a1,1,0,1,1-2,0V3.049A1.048,1.048,0,0,0,43.9,2H31.942l6.032,3.483A2.983,2.983,0,0,1,39.5,8.125v13.38h4.4a1.048,1.048,0,0,0,1.047-1.047V17.081a1,1,0,1,1,2,0v3.377a3.053,3.053,0,0,1-3.05,3.049Zm9.277-10.753-1.1,1.1a1,1,0,0,0,1.416,1.416L51.9,12.461a1,1,0,0,0,0-1.415L49.089,8.235A1,1,0,1,0,47.673,9.65l1.1,1.1H41.389a1,1,0,0,0,0,2h7.387Z",
    transform: "translate(-27.204 0)",
    fill: "#121212",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOtMenuIcon);
export default __webpack_public_path__ + "static/media/logOtMenuIcon.cab16aac51c182d0b3037d24f1c41c06.svg";
export { ForwardRef as ReactComponent };